module.exports = __webpack_public_path__ + "media/images/footer-bg-7c4a256c5bdb360205f7322bbf8cdebe.jpg";